import { useQuery } from '@tanstack/react-query';

import type { GetWithdrawalsOutput } from '@infinex/main-service-contract/v2/client/withdraw';

import type { Withdrawals } from './withdrawalTypes';

import type { QueryOptionsV2 } from '../config';
import { getTRPCClient } from '../config';

export const useWithdrawalsQuery = (
  options?: QueryOptionsV2<GetWithdrawalsOutput, Withdrawals>
) =>
  useQuery(
    getTRPCClient().withdraw.getWithdrawals.queryOptions(undefined, {
      ...options,
      select: (data) => data.withdrawals as Withdrawals,
    })
  );

type WithdrawalConfig = {
  minUsdAmount: GetWithdrawalsOutput['minUsdAmount'];
  maxDailyWithdrawals: GetWithdrawalsOutput['maxDailyWithdrawals'];
  maxDailyMoves: GetWithdrawalsOutput['maxDailyMoves'];
};

export const useWithdrawalConfigQuery = (
  options?: QueryOptionsV2<GetWithdrawalsOutput, WithdrawalConfig>
) =>
  useQuery(
    getTRPCClient().withdraw.getWithdrawals.queryOptions(undefined, {
      ...options,
      select: (data) => ({
        minUsdAmount: data.minUsdAmount,
        maxDailyWithdrawals: data.maxDailyWithdrawals,
        maxDailyMoves: data.maxDailyMoves,
      }),
    })
  );
